<template>
	<div>
		<!--        dialog aggiungi come domanda -->
		<el-dialog
			:close-on-click-modal="false"
			:title="$t('set-wiki')"
			:visible.sync="editWiki"
			width="60%"
			:before-close="
				() => {
					this.editWiki = false
				}
			"
		>
			<el-input type="textarea" :rows="2" :placeholder="$t('set-wiki-placeholder')" v-model="sel_el.wiki">
			</el-input>
		</el-dialog>
		<el-dialog
			:close-on-click-modal="false"
			:title="$t('set-question')"
			:visible.sync="editDialog"
			width="60%"
			:before-close="
				() => {
					this.editDialog = false
				}
			"
		>
			<div>
				<el-input
					v-if="typeof sel_el.question.value !== 'object' || !sel_el.question.value"
					type="textarea"
					:rows="2"
					:placeholder="$t('question-textarea')"
					v-model="sel_el.question.value"
				>
				</el-input>
				<div style="height: 100%" v-if="typeof sel_el.question.value === 'object' || !sel_el.question.value">
					<div v-if="!sel_el.question.value">oppure seleziona variabile</div>
					<div v-else>
						{{ $t("selected-var") }}: {{ sel_el.question.value.name }}
						<el-button @click="removeQuestionSoft" icon="el-icon-delete" type="danger" plain> </el-button>
					</div>
					<div v-if="!sel_el.question.value" style="height: 80%; overflow-y: auto">
						<div style="display: flex; justify-content: space-around">
							<el-input
								ref="varsearch"
								:placeholder="$t('search-variable')"
								style="width: 40%"
								v-model="filterSearch"
							></el-input>
							<el-select style="width: 60%" v-model="filters" multiple filterable>
								<el-option
									v-for="item in variableTypes"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
						</div>
						<div style="max-height: 300px; overflow-y: auto">
							<div
								v-for="b in vars"
								:key="b.index + vars.length"
								class="vertical-scroller-item"
								style="cursor: pointer; border: 1pt solid #ccc"
								@click="setVarAsQuestion(b)"
							>
								<div style="width: auto">
									<img :src="require('@/assets/icons/editor/variable.svg')" alt="dollar_alt" />
								</div>
								<div style="width: 45%">
									<p style="margin: 0 15px; font-weight: 500">{{ b.name | capitalize }}</p>
								</div>
								<div style="flex: 1; display: flex; justify-content: center">
									<el-tag v-if="b.level === -1">{{ $t("required-tag") }}</el-tag>
									<el-tag v-else-if="b.level === 0">{{ $t("global-tag") }}</el-tag>
									<el-tag v-else-if="b.level === 1">{{ $t("project-tag") }}</el-tag>
									<el-tag v-else-if="b.level === 2">{{ $t("procedure-tag") }}</el-tag>
									<el-tag v-else-if="b.level === 3">{{ $t("document-tag") }}</el-tag>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					v-if="
						typeof sel_el.question.value === 'object' &&
						(sel_el.question.value.type === 'image' ||
							sel_el.question.value.type === 'text' ||
							sel_el.question.value.type === 'long-text')
					"
				>
					<div
						:key="index"
						v-for="(el, index) in sel_el.question.map"
						style="display: flex; margin-bottom: 20px"
					>
						<strong style="margin-right: 10px; margin-top: 10px">{{ $t(el.value) }}</strong>

						<div v-if="el.value == 'contains'">
							<el-input
								style="border: 1pt solid #ccc; border-radius: 3pt"
								v-model="el.special_contains_value"
								:placeholder="$t('text-to-match')"
							/>
						</div>

						<el-select v-model="el.ref" style="width: 30%; margin: 0 25px">
							<el-option
								v-for="item in selected_nodes"
								v-if="item.id !== 0 && item.id !== selected_id"
								:key="item.id + '_select' + index"
								:label="item.titolo"
								:value="Number(item.id)"
							>
							</el-option>
						</el-select>
						<el-button
							v-if="el.value == 'contains'"
							@click="
								sel_el.question.map.splice(index, 1)
								editor.removeNodeOutput(selected_id, 'output_' + (index + 1))
							"
							icon="el-icon-delete"
							type="danger"
							plain
						>
						</el-button>
					</div>
					<el-button
						@click="
							sel_el.question.map.push({ value: 'contains' })
							editor.addNodeOutput(selected_id)
						"
						>+</el-button
					>
				</div>
				<div v-else-if="typeof sel_el.question.value === 'object' && sel_el.question.value.type === 'choice'">
					<div
						:key="index"
						v-for="(el, index) in sel_el.question.map"
						style="display: flex; margin-bottom: 20px"
					>
						<el-select multiple v-model="el.value" style="width: 30%; margin: 0 25px">
							<el-option
								v-for="item in JSON.parse(sel_el.question.value.rules).list"
								v-if="!sel_el.question.map.find(x => x.value.includes(item))"
								:key="item + '_choice' + index"
								:label="item"
								:value="item"
							>
							</el-option>
						</el-select>
						<el-select v-model="el.ref" style="width: 30%; margin: 0 25px">
							<el-option
								v-for="item in selected_nodes"
								v-if="item.id !== 0 && item.id !== selected_id"
								:key="item.id + '_select' + index"
								:label="item.titolo"
								:value="Number(item.id)"
							>
							</el-option>
						</el-select>
						<el-button
							v-if="index > 0"
							@click="
								sel_el.question.map.splice(index, 1)
								editor.removeNodeOutput(selected_id, 'output_' + (index + 1))
							"
							icon="el-icon-delete"
							type="danger"
							plain
						>
						</el-button>
					</div>
				</div>
				<div v-else-if="typeof sel_el.question.value === 'object' && sel_el.question.value.type === 'number'">
					<p style="font-size: 18px; margin-top: 25px; margin-bottom: 15px">{{ $t("answers") }}</p>
					<div
						:key="index"
						v-for="(el, index) in sel_el.question.map"
						style="display: flex; margin-bottom: 20px"
					>
						<el-select v-model="el.sign" placeholder="Select">
							<el-option key=">" label=">" value=">"> </el-option>
							<el-option key="<" label="<" value="<"> </el-option>
							<el-option key="=" label="=" value="="> </el-option>
							<el-option key=">=" label=">=" value=">="> </el-option>
							<el-option key="<=" label="<=" value="<="> </el-option>
						</el-select>
						<el-input-number
							:controls="false"
							placeholder="Condizione numerica"
							v-model="el.value"
							style="width: 50%"
						>
						</el-input-number>
						<el-select v-model="el.ref" style="width: 30%; margin: 0 25px">
							<el-option
								v-for="item in selected_nodes"
								v-if="item.id !== 0 && item.id !== selected_id"
								:key="item.id + '_number' + index"
								:label="item.titolo"
								:value="Number(item.id)"
							>
							</el-option>
						</el-select>
						<el-button
							v-if="index > 0"
							@click="
								sel_el.question.map.splice(index, 1)
								editor.removeNodeOutput(selected_id, 'output_' + (index + 1))
							"
							icon="el-icon-delete"
							type="danger"
							plain
						>
						</el-button>
					</div>
				</div>
				<div v-else-if="typeof sel_el.question.value === 'object' && sel_el.question.value.type === 'date'">
					<p style="font-size: 18px; margin-top: 25px; margin-bottom: 15px">{{ $t("answers") }}</p>
					<div
						:key="index"
						v-for="(el, index) in sel_el.question.map"
						style="display: flex; margin-bottom: 20px"
					>
						<el-select v-model="el.sign" placeholder="Select">
							<el-option key=">" label=">" value=">"> </el-option>
							<el-option key="<" label="<" value="<"> </el-option>
							<el-option key="=" label="=" value="="> </el-option>
							<el-option key=">=" label=">=" value=">="> </el-option>
							<el-option key="<=" label="<=" value="<="> </el-option>
						</el-select>

						<el-date-picker
							v-model="el.value"
							type="date"
							format="dd/MM/yyyy"
							value-format="dd/MM/yyyy"
							:placeholder="$t('pick-a-day')"
						>
						</el-date-picker>

						<el-select v-model="el.ref" style="width: 30%; margin: 0 25px">
							<el-option
								v-for="item in selected_nodes"
								v-if="item.id !== 0 && item.id !== selected_id"
								:key="item.id + '_number' + index"
								:label="item.titolo"
								:value="Number(item.id)"
							>
							</el-option>
						</el-select>
						<el-button
							v-if="index > 0"
							@click="
								sel_el.question.map.splice(index, 1)
								editor.removeNodeOutput(selected_id, 'output_' + (index + 1))
							"
							icon="el-icon-delete"
							type="danger"
							plain
						>
						</el-button>
					</div>
				</div>
				<div v-else>
					<p style="font-size: 18px; margin-top: 25px; margin-bottom: 15px">{{ $t("answers") }}</p>
					<div
						:key="index"
						v-for="(el, index) in sel_el.question.map"
						style="display: flex; margin-bottom: 20px"
					>
						<el-input :placeholder="$t('answer')" v-model="el.value" style="width: 50%"> </el-input>
						<el-select v-model="el.ref" :label="'text'" style="width: 30%; margin: 0 25px">
							<el-option
								v-for="item in selected_nodes"
								v-if="item.id !== 0 && item.id !== selected_id"
								:key="item.id + '_select' + index"
								:label="item.titolo"
								:value="Number(item.id)"
							>
							</el-option>
						</el-select>
						<el-button
							v-if="index > 0"
							@click="
								sel_el.question.map.splice(index, 1)
								editor.removeNodeOutput(selected_id, 'output_' + (index + 1))
							"
							icon="el-icon-delete"
							type="danger"
							plain
						>
						</el-button>
					</div>
				</div>
				<div
					style="display: flex; justify-content: center"
					v-if="
						typeof sel_el.question.value !== 'object' ||
						sel_el.question.value.type === 'choice' ||
						sel_el.question.value.type === 'number' ||
						sel_el.question.value.type === 'date'
					"
				>
					<el-button
						@click="
							sel_el.question.map.push({ value: '', ref: undefined })
							editor.addNodeOutput(selected_id)
						"
						plain
						icon="el-icon-plus"
					>
						{{ $t("add") }}
					</el-button>
				</div>
			</div>
			<div slot="footer">
				<div style="display: flex; justify-content: space-around">
					<el-button @click="removeQuestion()">{{ $t("question-delete") }}</el-button>
					<el-button type="primary" @click="confirmQuestion()">{{ $t("confirm") }}</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import axios from "axios"
import { filters } from "@/utils/utils"

export default {
	name: "flowchart-modals",
	mixins: [filters],
	data() {
		return {
			newVariablePopup: false,
			add: false,
			filters: [-1, 0, 1, 2, 3],
			filterSearch: "",
			vars: [],
			insvars: [],
			variableTypes: [
				{ value: -1, label: this.$t("required-tag") },
				{ value: 0, label: this.$t("global-tag") },
				{ value: 1, label: this.$t("project-tag") },
				{ value: 2, label: this.$t("procedure-tag") },
				{ value: 3, label: this.$t("document-tag") }
			]
		}
	},
	mounted() {
		axios
			.get(process.env.VUE_APP_API_URL + "/api/customfields/getByLevel", {
				headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
			})
			.then(res => {
				this.variables = []
				this.vars = []
				for (let i = 0; i < res.data.length; i++) {
					let temp = res.data[i]
					for (const [_, value] of Object.entries(temp)) {
						this.variables.push({
							index: value.id,
							name: value.name,
							type: value.type,
							level: value.level,
							rules: value.rules
						})
					}
				}
				this.vars = this.variables
			})
			.catch(err => {
				this.notification("warning", this.$t("warning"), this.$t("generic-error-msg"))
			})
	},
	watch: {
		filters: function (el) {
			this.vars = this.variables.filter(x => el.includes(x.level))
		},
		filterSearch: function (el) {
			this.vars = this.variables.filter(
				str =>
					str.name.replace(/\s+/g, "").toLowerCase().includes(el.replace(/\s+/g, "").toLowerCase()) &&
					this.filters.includes(str.level)
			)
		}
	},
	computed: {
		...mapGetters({
			selected_id: "flowchart/selected_id",
			selected_nodes: "flowchart/nodes",
			question: "flowchart/showModalQuestion",
			editProp: "flowchart/showModalInsert",
			editor: "flowchart/editor",
			showModalWiki: "flowchart/showModalWiki"
		}),
		sel_el: {
			get() {
				var indx = this.selected_nodes.findIndex(i => i.id == this.selected_id)
				return this.selected_nodes[indx]
			},
			set(val) {
				var indx = this.selected_nodes.findIndex(i => i.id == this.selected_id)
				this.selected_nodes[indx] = val
			}
		},
		editDialog: {
			get() {
				return this.question
			},
			set() {
				this.endSetQuestion()
			}
		},
		editWiki: {
			get() {
				return this.showModalWiki
			},
			set() {
				this.editWikiModal({ val: false, id: undefined })
			}
		},
		propDialog: {
			get() {
				return this.editProp
			},
			set() {
				this.endSetProp()
			}
		},
		inputs: {
			async get() {
				return await this.editor.getNodeFromId(this.selected_id).inputs
			},
			set(val) {
				this.editor.updateNodeDataFromId(this.selected_id, { inputs: val })
			}
		},
		outputs: {
			async get() {
				return await this.editor.getNodeFromId(this.selected_id).outputs
			},
			set(val) {
				this.editor.updateNodeDataFromId(this.selected_id, { outputs: val })
			}
		}
	},
	methods: {
		editValues(value, e) {
			value = e + value
		},
		async setVarAsQuestion(b) {
			switch (true) {
				case b.type === "choice":
				case b.type === "number":
					this.sel_el.question.value = b
					this.sel_el.question.map = [{ value: "" }]
					break
				case b.type === "image":
					this.sel_el.question.value = b
					this.sel_el.question.map = [{ value: "is_compiled" }, { value: "not_compiled" }]
					await this.editor.addNodeOutput(this.selected_id)

					break
				case b.type === "text":
					this.sel_el.question.value = b
					this.sel_el.question.map = [
						{ value: "is_compiled" },
						{ value: "not_compiled" },
						{ value: "contains" }
					]
					await this.editor.addNodeOutput(this.selected_id)
					await this.editor.addNodeOutput(this.selected_id)

					break
				case b.type === "long-text":
					this.sel_el.question.value = b
					this.sel_el.question.map = [
						{ value: "is_compiled" },
						{ value: "not_compiled" },
						{ value: "contains" }
					]
					await this.editor.addNodeOutput(this.selected_id)
					await this.editor.addNodeOutput(this.selected_id)

					break
				case b.type === "date":
					this.sel_el.question.value = b
					this.sel_el.question.map = [{ value: "" }]

					break
				default:
					break
			}
		},
		...mapActions({
			endSetQuestion: "flowchart/endSetQuestion",
			setQuestion: "flowchart/setQuestion",
			resetQuestion: "flowchart/resetQuestion",
			editNodeValue: "flowchart/editNodeValue",
			setNode: "flowchart/setNode",
			editNode: "flowchart/editNode",
			editWikiModal: "flowchart/editWikiModal"
		}),
		removeQuestion() {
			this.resetQuestion(this.selected_id)
			this.editDialog = false
			this.endSetQuestion()
		},
		removeQuestionSoft() {
			this.removeQuestion()
		},
		async confirmQuestion() {
			var output = 0
			var indx = this.selected_nodes.findIndex(i => i.id == this.selected_id)
			var node2 = await this.editor.getNodeFromId(this.selected_id)
			var tmpSave = node2.outputs.length
			for (const [indx3, el] of Object.entries(node2.outputs)) {
				if (el.connections.length) {
					for (const [indx2, el2] of Object.entries(el.connections)) {
						try {
							await this.editor.removeSingleConnectionWithoutDispatch(
								indx,
								Number(el2.node),
								indx3,
								el2.output
							)
						} catch (e) {
							console.error(e)
						}

						//in caso di emergenza, scommentare riga sotto
						//await this.editor.removeSingleConnection(indx, el2.node, indx3, el2.output)
						//non definito
						// var inputindx = this.selected_nodes.findIndex(i => i.id == indx3)
						// this.selected_nodes[inputindx].parent = this.selected_nodes[inputindx].parent.filter(
						// 	a => a !== indx
						// )

						var node2 = this.selected_nodes.find(i => i.id == el2.node)
						if (node2) {
							/*cose grafiche */
							const nodes = Array.from(document.querySelectorAll("[id^=node]"))
							// toglie il colore alle bubble di input e output

							const dstNode = nodes.filter(x => x.id.split("-")[1] === String(Number(el2.node)))[0]
								.childNodes[0]

							if (dstNode.querySelector(`.input.${el2.output}`)) {
								dstNode.querySelector(`.input.${el2.output}`).style.backgroundColor = "#fff"
							}

							var ind2 = node2.parent.findIndex(i => i == el2.output)
							node2.parent.splice(ind2, 1)
						}
					}
					this.selected_nodes[indx].children = []
				}
			}

			for (var index = 0; index < this.selected_nodes[indx].question.map.length; index++) {
				var el = this.selected_nodes[indx].question.map[index]
				output++
				if (el.ref !== undefined) {
					var node = await this.editor.getNodeFromId(el.ref)

					var redo = true

					for (const id of Object.keys(node.inputs)) {
						try {
							await this.editor.removeSingleConnectionWithoutDispatch(
								this.selected_id,
								el.ref,
								"output_" + (index + 1),
								id
							)
							await this.editor.addConnection(this.selected_id, el.ref, "output_" + (index + 1), id)
							redo = false
							break
						} catch (e) {
							redo = true
						}
					}
					if (redo) {
						await this.editor.addNodeInput(el.ref)
						node = await this.editor.getNodeFromId(el.ref)

						await this.editor.addConnection(
							this.selected_id,
							el.ref,
							"output_" + (index + 1),
							"input_" + Object.keys(node.inputs).length
						)
					}
				}
			}
			await this.setQuestion(this.selected_id)
			this.editDialog = false
			this.endSetQuestion()
		}
	}
}
</script>
<style>
.el-dialog__footer {
	background-color: #f2f2f2 !important;
}

.el-dialog__header span {
	font-size: 24px;
	font-weight: 500;
}

.el-dialog {
	border-radius: 5px !important;
}
</style>
